import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

/** Crew-only word hints under the secret word (reveal phase); horizontal row with wrap. */
export function ImposterOnlineCrewHintsRow({
  hints,
  hintsLabel,
  color,
  labelColor,
  labelColorMix,
}: {
  hints: string[];
  hintsLabel: string;
  /** Main text color (e.g. ``partyPal.paperInk``). */
  color: string;
  /** Small heading color; overrides ``labelColorMix`` when set. */
  labelColor?: string;
  /** Optional CSS color for the small label; defaults to a mix of ``color``. */
  labelColorMix?: string;
}) {
  if (hints.length === 0) return null;
  const labelTint = labelColor ?? labelColorMix ?? `color-mix(in oklab, ${color} 72%, transparent)`;
  return (
    <Box sx={{ mt: 2, width: "100%" }}>
      <Typography className="party-mono" sx={{ fontSize: 10, opacity: 0.55, mb: 0.75, textAlign: "center", color: labelTint }}>
        {hintsLabel}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: 1.25,
          rowGap: 0.75,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {hints.map((line, hi) => (
          <Typography key={`${hi}:${line}`} component="span" sx={{ fontSize: 15, fontWeight: 700, color, lineHeight: 1.4 }}>
            · {line}
          </Typography>
        ))}
      </Box>
    </Box>
  );
}
